export default "__VITE_ASSET__V3RhmI90__"